// extracted by mini-css-extract-plugin
export default {"teacherContainer":"ExamPdfs_teacherContainer__KxyjC","lessonsContainer":"ExamPdfs_lessonsContainer__bLbnS"};